import React from 'react';
import PropTypes from 'prop-types';

function PlusIcon(props) {
    const {className} = props;
    return (
        <svg width='14' height='14' viewBox='0 0 14 14' fill='none' className={className}>
            <path d='M2 7H12M7 2V12' stroke='#fff' strokeWidth='2' strokeLinecap='round' />
        </svg>
    );
}

PlusIcon.propTypes = {
    className: PropTypes.string,
};

PlusIcon.defaultProps = {
    className: '',
};

export default PlusIcon;



// WEBPACK FOOTER //
// ./src/components/controls/icons/PlusIcon.jsx